import IncentiveView from "./IncentiveView";

export default IncentiveView;